module.exports = __webpack_public_path__ + "static/media/41.32fccc3f.png";